import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useEffect } from 'react';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { useDispatch, useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { Stack, Dialog, DialogTitle, DialogContent, MenuItem, DialogActions, Button } from '@mui/material';
import { FormProvider, RHFSelect } from '../../../components/hook-form';

import { getAuditBranches } from '../../branches/store/branchActions';

const ROLES = [
  {
    id: 1,
    label: 'Admin',
    value: 'ADMIN',
  },
  {
    id: 1,
    label: 'Assistant Manager',
    value: 'ASST_MANAGER',
  },
  {
    id: 2,
    label: 'Auditor',
    value: 'AUDITOR',
  },
  { id: 8, label: 'Director', value: 'DIRECTOR' },
  {
    id: 5,
    label: 'Data Entry',
    value: 'DATA_ENTRY',
  },
  {
    id: 2,
    label: 'Manager',
    value: 'MANAGER',
  },
  {
    id: 3,
    label: 'Regional Manager',
    value: 'REGIONAL_MANAGER',
  },

  {
    id: 6,
    label: 'Service Provider',
    value: 'SERVICE_PROVIDER',
  },
];

// The shape of the filter, in one place: the page owns the values so they
// survive paging, and hands them back here as the form's starting point.
export const EMPTY_USER_FILTERS = {
  locationId: '',
  role: '',
  // Not a field in this dialog — it is the table's search box — but part of
  // the filter set, so it is carried through rather than wiped when this
  // dialog is applied. It replaced `name`, which matched the display name and
  // nothing else.
  searchTerm: '',
};

UsersFilter.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  values: PropTypes.object,
  onApply: PropTypes.func.isRequired,
};

export default function UsersFilter({ open, handleClose, values = EMPTY_USER_FILTERS, onApply }) {
  const dispatch = useDispatch();
  const { auditBranches } = useSelector((state) => state.branchReducer);

  const filterSchema = Yup.object().shape({});

  // Reopening the dialog shows what is currently applied, rather than blanks
  // over a filtered table.
  const defaultValues = { ...EMPTY_USER_FILTERS, ...values };

  const methods = useForm({
    resolver: yupResolver(filterSchema),
    defaultValues,
  });

  const {
    reset,
    // watch,
    // control,
    // setValue,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  // const values = watch();

  // The page fetches; this dialog only says what to fetch. It used to dispatch
  // the filtered request itself, which is why paging — driven from the page —
  // dropped straight back to the unfiltered list.
  const onSubmit = async (data) => {
    onApply({ ...EMPTY_USER_FILTERS, ...values, ...data });
    handleClose();
  };

  const handleClear = () => {
    reset(EMPTY_USER_FILTERS);
    // Clears this dialog's fields. The search box has its own Clear.
    onApply({ ...EMPTY_USER_FILTERS, searchTerm: values.searchTerm || '' });
    handleClose();
  };
  useEffect(() => {
    dispatch(getAuditBranches({}));
  }, [dispatch]);
  return (
    <Dialog
      maxWidth="md"
      open={open}
      fullWidth
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>Filter Users</DialogTitle>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <DialogContent dividers>
          <Stack spacing={2}>
            <RHFSelect
              fullWidth
              name="locationId"
              label="Branch"
              InputLabelProps={{ shrink: true }}
              SelectProps={{ native: false, sx: { textTransform: 'capitalize' } }}
            >
              {auditBranches?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </RHFSelect>
            <RHFSelect
              fullWidth
              name="role"
              label="Role"
              InputLabelProps={{ shrink: true }}
              SelectProps={{ native: false, sx: { textTransform: 'capitalize' } }}
            >
              {ROLES?.map((option) => (
                <MenuItem key={option.id} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </RHFSelect>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="contained" color="error" onClick={handleClose}>
            Cancel
          </Button>
          <Button size="small" variant="outlined" onClick={handleClear}>
            Clear
          </Button>
          <LoadingButton type="submit" size="small" variant="contained" loading={isSubmitting}>
            Filter
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
